import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { selectedRanks } from '../../components/muiLegacy/Select/AverageCTRMultiSelect';
import { ProjectGq } from '../../graphql/projects/models/ProjectGq';
import { DownloadAnalysisTheme } from '../../graphql/projects/mutations/projects/useDownloadAnalysisGq';
import { AnalysisFilterState } from './Filter/analysisFilterState';
import { internationalText, Language } from './internationalText';

export interface ChartAnnotationProps {
  project: ProjectGq;
  analysisFilterState: AnalysisFilterState;
  language: Language;
  slideTheme: DownloadAnalysisTheme;
}

export const ChartAnnotation: React.FC<ChartAnnotationProps> = ({
  analysisFilterState,
  project,
  language,
  slideTheme,
}) => {
  const annotations: string[] = [];

  if (analysisFilterState?.shownFields.showTagGroupId && analysisFilterState?.tagGroupId > 0) {
    annotations.push(
      `${internationalText.annotation.tag_group[language]}: ${
        project?.tagGroups?.find((tg) => tg.id === analysisFilterState?.tagGroupId)?.name ?? '-'
      }`
    );
  }

  if (
    analysisFilterState?.shownFields.showTagGroupId &&
    analysisFilterState?.shownFields.showTagId &&
    analysisFilterState?.tagGroupId > 0 &&
    analysisFilterState?.tagId > 0
  ) {
    annotations.push(
      `${internationalText.annotation.tag[language]}: ${
        project?.tagGroups
          ?.find((tg) => tg.id === analysisFilterState?.tagGroupId)
          ?.tags?.find((t) => t.id === analysisFilterState.tagId)?.name ?? '-'
      }`
    );
  }

  if (
    analysisFilterState?.shownFields.showBaselineRankValues &&
    analysisFilterState?.baselineRankValues?.length
  ) {
    annotations.push(
      `${internationalText.annotation.baseline_ctr_avg[language]}: ${selectedRanks(
        analysisFilterState?.baselineRankValues
      )}`
    );
  }

  if (
    analysisFilterState?.shownFields.showTargetRankValues &&
    analysisFilterState?.targetRankValues?.length
  ) {
    annotations.push(
      `${internationalText.annotation.target_ctr_avg[language]}: ${selectedRanks(
        analysisFilterState?.targetRankValues
      )}`
    );
  }

  if (analysisFilterState?.shownFields.showRampUpTime) {
    annotations.push(
      `${internationalText.annotation.ramp_up_time[language]}: ${analysisFilterState?.rampUpTime} ${
        language === 'en' ? 'months' : 'månader'
      }`
    );
  }
  if (
    analysisFilterState?.shownFields.showConversionRate &&
    analysisFilterState?.conversionRate.length
  ) {
    annotations.push(
      `${internationalText.annotation.conversion_rate[language]}: ${analysisFilterState?.conversionRate}%`
    );
  }
  if (
    analysisFilterState?.shownFields.showAverageOrderValue &&
    analysisFilterState?.averageOrderValue.length
  ) {
    annotations.push(
      `${internationalText.annotation.average_order_value[language]}: ${analysisFilterState?.averageOrderValue} ${project.currency}`
    );
  }

  // Render
  if (!annotations.length) return null;
  return (
    <div className="w-full flex flex-row gap-2 justify-center mt-4">
      {annotations.map((annotation, index) => (
        <div
          key={index}
          className={`rounded-full bg-voxel-gray-200 whitespace-nowrap text-[13px] px-2.5 py-1 
          ${slideTheme === 'voxel' ? 'font-voxel-charts' : 'font-pixel-charts'}`}
        >
          {annotation}
        </div>
      ))}
    </div>
  );
};

export default ChartAnnotation;
